import { call, put, takeLatest } from 'redux-saga/effects';
import axios from 'axios';
import { REQUEST, fetchSuccess, fetchFailure } from '../../actions/signals/displayName';
import config from '../../../config';
import { getLocalUser } from '../../../utils/localUser';
import { Error } from '../../actions/error/error';
import { extractErrorMessage } from '../../../utils/apiResponseHandler';

function* operation(action) {
  const { key, display_name } = action?.payload || {};
  try {
    yield call(
      axios.post,
      `${config.API_URL}/signal/display-name`,
      { key, display_name },
      { headers: getLocalUser() },
    );
    // Echo the request inputs so the list can update the renamed row
    // locally (the BE enriches the next GET /signal with the same name).
    yield put(fetchSuccess({ key, display_name, at: Date.now() }));
  } catch (error) {
    yield put(Error(error));
    yield put(fetchFailure(extractErrorMessage(error)));
  }
}

export function* watch() {
  yield takeLatest(REQUEST, operation);
}
